import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-technical-description',
  templateUrl: './technical-description.component.html',
  styleUrls: ['./technical-description.component.scss']
})
export class TechnicalDescriptionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
